import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {UserAccount} from '../../configuration-management/models/user.interface';
import {AccountService} from '../../configuration-management/services/account.service';
import {FormControl} from '@angular/forms';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-multiselect-staff',
  templateUrl: './multiselect-staff.component.html',
  styleUrls: ['./multiselect-staff.component.css']
})
export class MultiselectStaffComponent implements OnInit, OnDestroy {

  staffList: UserAccount[];
  selectedRecipientNames: string[];
  formSearch: FormControl = new FormControl('');

  @Input() control: FormControl;
  @Input() label: string;

  subscriptions: Subscription = new Subscription();


  constructor(
    public accountService: AccountService
  ) {
  }

  ngOnInit() {
    this.subscriptions.add(this.control.valueChanges.subscribe(this.updateSelectedRecipientNames.bind(this)));
    this.subscriptions.add(this.accountService.getUsers().subscribe(res => {
      const userIds: string[] = [];
      const userSet: UserAccount[] = [];
      res.forEach(user => {
        if (!userIds.includes(user.id)) {
          userIds.push(user.id);
          userSet.push(user);
        }
      });
      this.staffList = userSet.sort((a, b) => a.lastName.localeCompare(b.lastName));
      this.updateSelectedRecipientNames();
    }));
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  updateSelectedRecipientNames() {
    const selected = this.staffList.filter(user => this.control.value.includes(user.id));
    this.selectedRecipientNames = selected.map(user => `${user.firstName} ${user.lastName}`);
  }
}
